
export default {
  SET_VENDOR_PRODUCT(state, vendorProduct) {
    state.vendorProduct = vendorProduct;
  },

  ADD_VENDOEP_RODUCT(state, vendorProduct){
    state.vendorProducts.unshift(vendorProduct);
  },

  EDIT_VENDOR_PRODUCT(state, vendorProduct) {
    state.vendorProducts = state.vendorProducts.map(item => {
      if(item.vendor_product_uuid === vendorProduct.vendor_product_uuid) {
        return vendorProduct;
      } 

      return item;
    })
  },

  SET_ALL_VENDOR_PRODUCTS(state, {vendorProducts, total, per_page}) {
    state.vendorProducts = vendorProducts;
    state.totalPage = total / per_page;
    state.totalItems = total;
  },
  
  REMOVE_VENDOR_PRODUCT(state, vendor_product_uuid) {
    state.vendorProducts = state.vendorProducts.filter(vendorProduct => vendorProduct.vendor_product_uuid !== vendor_product_uuid);
  },

  UPDATE_VENDOR_PRODUCT(state, fields) {
    let copyVendorProduct = {...state.vendorProduct};

    state.vendorProduct = {...copyVendorProduct, ...fields};
  }
};
